import React from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState, useEffect } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../config";
import CriteriaTable from "../../components/master/CriteriaTable";
import { authFetch } from "../../utility/AuthFetch";

function Criteria() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(0);
  const [criteria, setCriteria] = useState("");
  const [exam, setExam] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);
    const url = editMode
      ? `${API_BASE_URL}/api/edit-criteria-master`
      : `${API_BASE_URL}/api/criteria-master`;

    if (editMode) {
      formData.append("ID", editId);
    }

    const method = editMode ? "PUT" : "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert(
          editMode
            ? "Criteria updated successfully"
            : "Criteria added successfully",
        );
        formRef.current.reset();
        setIsSubmitting(false);
        setCriteria("");
        setExam("");
        setEditMode(false);
        setLoader(false);
        setEditId(null);
        setReload((prev) => prev + 1);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  const handleEdit = (item) => {
    setCriteria(item.criteria);
    setExam(item.exam);
    setEditId(item.id);
    setEditMode(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Criteria Master</h5>
            <Form onSubmit={handleSubmit} ref={formRef}>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formGrade">
                    <Form.Label>
                      Criteria <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="criteria"
                      required
                      value={criteria}
                      onChange={(e) => {
                        setCriteria(e.target.value);
                      }}
                      placeholder="Enter Critera"
                      autoComplete="off"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formType">
                    <Form.Label>
                      Exam Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="exam"
                      value={exam}
                      onChange={(e) => setExam(e.target.value)}
                      required
                    >
                      <option value="" disabled>
                        Select Exam Type
                      </option>
                      <option value="half-yearly">Half Yearly</option>
                      <option value="annual">Annual</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {editMode ? "UPDATE" : "SUBMIT"}
              </Button>
            </Form>
          </div>

          <div className="container bg-white p-4 rounded shadow-sm mt-4">
            <h5 className="mb-3">Criteria List</h5>
            <CriteriaTable onEdit={handleEdit} reload={reload} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Criteria;
